module.exports = __webpack_public_path__ + "images/emoji/herb.d9d05763148f0b685d8e.png";